import React from "react";
import ReactDOM from "react-dom/client";
import { Router } from "react-router-dom";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import * as Sentry from "@sentry/react";

import App from "./blocks/app/app";

import "styles/main.scss";
import "styles/tailwind.css";
import "react-loading-skeleton/dist/skeleton.css";
import ModalContextProvider from "./contexts/modal-context";
import UiContextProvider from "./contexts/ui-context";
import { MainStoreProvider } from "./stores/Main";
import history from "./utils/history";
import ModalManager from "./blocks/modal-manager/modal-manager";

// Parse hash parameters for PostHog ID bootstrapping
const hashParams = new URLSearchParams(window.location.hash.substring(1));
const distinct_id = hashParams.get('distinct_id');
const session_id = hashParams.get('session_id');

if (process.env.REACT_APP_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    defaults: "2025-05-24",
    bootstrap: distinct_id && session_id ? {
      distinctID: distinct_id,
      sessionID: session_id,
    } : undefined,
    loaded: (posthog) => {
      // Set super properties that will be included with every event
      posthog.register({
        source: "freede-platform",
      });
    },
  });
}

// Pipe console to null for everything but development env
if (process.env.NODE_ENV !== "development") console.log = () => {};

if (process.env.REACT_APP_ENABLE_SENTRY) {
  Sentry.init({
    dsn: "https://fb21c75802a194ef7dda352287400190@o1279318.ingest.sentry.io/4506662436274176",
    debug: process.env.NODE_ENV === "development",
    environment: process.env.NODE_ENV,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <MainStoreProvider>
        <ModalContextProvider>
          <UiContextProvider>
            <Router history={history}>
              <App />
            </Router>
            <ModalManager />
          </UiContextProvider>
        </ModalContextProvider>
      </MainStoreProvider>
    </PostHogProvider>
  </React.StrictMode>
);
